import checkTypeValidity from '../type-check/check-type-validity.js';

/**
 * @func formatWithCommas
 * @param {number} value - The number to be formatted.
 * @param {number} maximumFractionDigits - optional maximum decimal parameter defaults to 2
 * @param {number} minimumFractionDigits - optional minimum decimal parameter defaults to 0
 * @return {string}
 * @desc Formats numbers with commas
 *```js
 * formatWithCommas(1000);
 * // returns "1,000";
 * ```
 * @memberof module:Number
 * @instance
 */
function formatWithCommas(value, maximumFractionDigits = 2, minimumFractionDigits = 0) {
    return checkTypeValidity(['number', 'numericalString'], value)
        ? new Intl.NumberFormat('en-US', {
            maximumFractionDigits,
            minimumFractionDigits,
        }).format(Number(value))
        : null;
}

export { formatWithCommas as default };
